"use client"

import { createContext, useContext } from "react"

import type { createDialogCloseRegistry } from "./dialog-behavior"

export const DialogCloseContext = createContext<ReturnType<typeof createDialogCloseRegistry> | null>(null)
export const useDialogCloseRegistry = () => useContext(DialogCloseContext)
